// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"819926c9","538":"acd25931","784":"a194e56d"}[chunkId] + ".chunk.css";
};